;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.order.show')
    .controller('OrderShowToolbarController', OrderShowToolbarController)

  OrderShowToolbarController.$inject = [
    // Angular
    '$rootScope', '$scope', '$state',

    // Services
    'UtilService', 'SnackService', 'DisplayService',

    // Resolve
    'order', 'template'

  ]

  function OrderShowToolbarController (
    // Angular
    $rootScope, $scope, $state,

    // Services
    UtilService, SnackService, DisplayService,

    // Resolve
    order, template

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        order: order,
        template: template,
        title: order.title,
        status: order.status,
        number: getOrderNumber(),
        newSituation: newSituation,
        archiveOrder: archiveOrder,
        restoreOrder: restoreOrder
      })
    }

    $scope.$watch(function () {
      return template
    }, function () {
      self.template = template
      self.number = getOrderNumber()
    })

    function getOrderNumber () {
      if (order.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(order, 'order', order.numberFormat)
    }

    function newSituation () {
      self.new = true
      $rootScope.$emit('newSituation')
    }

    function archiveOrder () {
      var content = "Vous êtes sur le point d'archiver ce chantier.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?"
      DisplayService.displayConfirm('Archiver', content).then(function () {
        order.archive().then(function () {
          SnackService.snack({
            text: 'Chantier archivé !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreOrder () {
      var content = 'Vous êtes sur le point de restaurer ce chantier.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        order.restore().then(function () {
          SnackService.snack({
            text: 'Chantier restauré !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }
  }
})(window.angular, window._)
